import React from "react";

import SampleProductsSection from "./sample-products-section";
import Header from "../../../../layouts/AuthLayout/header/header";

export default function PersonalizedSampleProductsPage() {
  return (
    <>
      <Header />
      <SampleProductsSection />
    </>
  );
}
